/**
 * Textarea
 */
export class GMXTextarea extends HTMLElement {
	textAreaEl: HTMLTextAreaElement

	private boundInputEventHandler = this._handleInputEvent.bind(this)

	connectedCallback(): void {
		this.textAreaEl = this.querySelector('textarea')

		if (this.textAreaEl) {
			this.textAreaEl.addEventListener('input', this.boundInputEventHandler)
		} else {
			window.console.error(`ERROR:  GMX Textarea missing <textarea> element`)
		}
	}

	disconnectedCallback(): void {
		if (this.textAreaEl) {
			this.textAreaEl.removeEventListener('input', this.boundInputEventHandler)
		}
	}

	/**
	 * Method to handle when the component's inner <input> element's value changes
	 * @private
	 */
	private _handleInputEvent(): void {
		if (this.textAreaEl.value) {
			this.textAreaEl.classList.add('filled')
		} else {
			this.textAreaEl.classList.remove('filled')
		}
	}
}
if (!customElements.get('gmx-textarea')) {
	customElements.define('gmx-textarea', GMXTextarea)
}
